let n = [];
const a = /* @__PURE__ */ new WeakMap();
function r() {
  n.forEach((e) => e(...a.get(e))), n = [];
}
function s(e, ...t) {
  a.set(e, t), !n.includes(e) && n.push(e) === 1 && requestAnimationFrame(r);
}
export {
  s as beforeNextFrameOnce
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/seemly@0.3.10/~/seemly/es/animation/next-frame-once.js
// module id = 335
// module chunks = 67